var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.stamp_tab},[_c('div',{class:_vm.$style.tab_header}),_c('div',{class:_vm.$style.stamp_tab_action},[_c('base-button',{attrs:{"width":"185px","rounded":"rounded"},on:{"click":_vm.commentDelete}},[_vm._v("削除")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }